import { render, staticRenderFns } from "./ElPostGrid.vue?vue&type=template&id=79159162"
import script from "./ElPostGrid.vue?vue&type=script&lang=js"
export * from "./ElPostGrid.vue?vue&type=script&lang=js"
import style0 from "./ElPostGrid.vue?vue&type=style&index=0&id=79159162&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports